import type { ConfigType } from '@plone/registry';
import { SITE_CONFIGS, siteIdFromEnv } from '../siteConfig/branding';

export default function install(config: ConfigType) {
  // Language settings
  config.settings.isMultilingual = false;
  config.settings.supportedLanguages = ['en'];
  config.settings.defaultLanguage = 'en';

  // match the live archives: no tag chips / Related Items section under the
  // content view (relations show in the document tabs instead)
  config.settings.showTags = false;
  config.settings.showRelatedItems = false;

  // This instance's PUBLIC origin — the CLIENT half. (item 12)
  //
  // `publicURL` is what core turns into every absolute URL it owns:
  // `toPublicURL` feeds ContentMetadataTags' <link rel="canonical"> and og:url
  // on every page this addon does not give its own SEO head, and it builds
  // every <loc> in the sitemaps. Left to core it is DERIVED FROM THE REQUEST,
  // which behind the public edge means the right host and the wrong scheme
  // (that nginx block forwards Host but not X-Forwarded-Proto). Audited from
  // the internal address it was worse still: `http://127.0.0.1:9090`, one node
  // process announcing itself to crawlers as the address of the archive.
  //
  // This is an ENV fact, not a request fact: RAZZLE_SITE_ID binds each of the
  // three instances to exactly one archive, and `runtimeConfig` carries that
  // value identically to the server and the client (window.env), so both sides
  // assert the same constant and the server-rendered canonical survives
  // hydration unchanged. Same source as every other per-site value, so the
  // three origins cannot drift from the three brands.
  //
  // THIS ASSIGNMENT ALONE IS NOT ENOUGH, and the reason is easy to trip over:
  // on the server, core's setupServer is registered as `server.all('*', …)`,
  // ahead of `expressMiddleware`, so it overwrites this on every request.
  // express/publicOrigin.js re-asserts it at the one seam that runs after that
  // clobber and before anything reads it. Both halves are required; neither is
  // redundant. See that file for the full ordering.
  //
  // Not touched here or there: `apiPath`. It must keep the REQUEST's origin —
  // it is how the browser and the SSR pass reach `/++api++` on the host they
  // are actually talking to. publicURL is "where this archive lives on the
  // internet"; apiPath is "where to send the next fetch".
  const siteId = siteIdFromEnv();
  const baseUrl = siteId && SITE_CONFIGS[siteId]?.baseUrl;
  if (baseUrl) {
    config.settings.publicURL = baseUrl.replace(/\/+$/, '');
  }

  return config;
}
